import { Card, CardActions, CardContent, CircularProgress, Typography } from "@mui/material"
import React from "react"
import SimpleTable from "../../components/Common/Elements"
import { useIsCheaterV1CmQuery } from "../../core/api/clockmaker-social-api"
import CmUnbanControl from "./CmUnbanControl"
import CmBanControl from "./CmBanControll"

const CmBanStatusCard = ({ userId, userState }) => {
    const { data, isLoading, isFetching } = useIsCheaterV1CmQuery(
        userId,
        { skip: userId === "" }
    )

    return (
        <Card>
            <CardContent>
                <Typography
                    sx={{
                        pb: 2,
                        fontSize: 16
                    }}>
                    Ban Status
                </Typography>
                {
                    isLoading || isFetching
                        ? (
                            <CircularProgress />
                        )
                        : (
                            <SimpleTable
                                data={[
                                    ["Game Ban", userState?.["Chtr"]?.toString() ?? "false"],
                                    ["Server Ban", data?.toString() ?? "N/A"]
                                ]}
                            />
                        )
                }
            </CardContent>
            <CardActions>
                <CmBanControl disabled={isLoading || isFetching} userId={userId} />
                <CmUnbanControl disabled={isLoading || isFetching} userId={userId} />
            </CardActions>
        </Card>
    );
}

export default CmBanStatusCard
